module.exports = __webpack_public_path__ + "static/headshot-mitchell-grenier-2x.fe488a46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mitchell-grenier-2x.jpg
// module id = 132
// module chunks = 35783957827783 152909308826437